import {
  AutoComplete,
  ISelectType,
  useFetch,
  useFormContext,
} from "@4uhub/lib4uhub";
import { memo, useCallback, useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { getPhysiciansList } from "../../../../../../../../services/tasyPhysician.service";
import { TUnchosenProfessionalPriorityForm } from "../unchosenProfessionalPrioritySchema";
import { IUnchosenProfessionalPhysiciansProps } from "./models";

const translationPath =
  "chatBot.page.automations.automationReceivedRules.ticketAutRecRuleUnchosenProfessionalRule.";

export const UnchosenProfessionalPhysicians = memo(
  ({ index }: IUnchosenProfessionalPhysiciansProps) => {
    const { t } = useTranslation();

    const [physicians, setPhysicians] = useState<ISelectType[]>([]);

    const [searchBy, setSearchBy] = useState<string>("");

    const { sendRequest: getPhysiciansListReq } = useFetch(getPhysiciansList);

    const { setValue, clearErrors, trigger } =
      useFormContext<TUnchosenProfessionalPriorityForm>();

    const handleChangeValues = useCallback(() => {
      setValue(`thenPriorities.${index}.calendars`, null);
      clearErrors(`thenPriorities.${index}.calendars`);
      trigger([
        `thenPriorities.${index}.calendars`,
        `thenPriorities.${index}.physicians`,
      ]);
    }, [index, setValue, clearErrors, trigger]);

    const handleFetchPhysicians = useCallback(async () => {
      if (!searchBy || searchBy?.trim() === "" || searchBy.length < 3) return;
      const { data, success } = await getPhysiciansListReq({
        SearchBy: searchBy,
        EnableCode: true,
      });
      if (success && data) {
        const mappedItems: ISelectType[] = data.map((item) => {
          return {
            id: item.identifier,
            name: item.individualName,
            code: item.identifier,
          };
        });
        setPhysicians(mappedItems);
      }
    }, [getPhysiciansListReq, searchBy]);

    useEffect(() => {
      handleFetchPhysicians();
    }, [handleFetchPhysicians]);

    const handleSetSearchBy = useCallback((search: string) => {
      setSearchBy(search);
    }, []);

    return (
      <AutoComplete
        getOptionLabel={({ name }) => name}
        name={`thenPriorities.${index}.physicians`}
        label={t(translationPath + "physicians")}
        size="small"
        options={physicians}
        SearchAsYouTypeParams={handleSetSearchBy}
        onAfterValueChange={handleChangeValues}
        fullWidth
      />
    );
  },
);
